import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from '../../services/users.service';
import { Location } from '@angular/common'
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PrintService } from '../../services/print.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

@Component({
	selector: 'app-user-groups',
	templateUrl: './user-groups.component.html',
	styleUrls: ['./user-groups.component.scss']
})
export class UserGroupsComponent implements OnInit {
	usergroups: any = [];
	allUsergroups: any = []
	color = '';
	filename = 'usergroups_list';
	exporting = false;
	@ViewChild('addGroupInput') addGroupRef: ElementRef;
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	addGroupForm: UntypedFormGroup;
	usergroupSearch = new FormControl('')
	isSearching = false
	headercolumns: string[] = [
		'actions',
		'user_group_id',
		'name',
		'sales_channel',
		'user_count'
	]
	placedfrom = [{
		name: 'BackOffice',
		value: 1
	},
	{
		name: 'Point Of Sale',
		value: 2
	},
	{
		name: 'Street',
		value: 3
	},
	{
		name: 'Ecom',
		value: 4
	},
	{
		name: 'Retail',
		value: 5
	}]

	allUsers: any = [];

	constructor(private fb: UntypedFormBuilder, private globalSearchService: GlobalSearchService, private route: ActivatedRoute, public router: Router, private userService: UsersService, private location: Location, private modalService: NgbModal, private printService: PrintService) {

		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {


		this.addGroupForm = this.fb.group({
			user_group_id: [''],
			name: ['', Validators.required],
			permission: [''],
			access: [''],
		});


		this.userService.getUserGroups().subscribe((groups: any) => {
			this.allUsergroups = groups
			this.setTableData(groups)
		});
	}
	getUsers() {
		this.userService.getUsers().subscribe((users: any) => {
			this.allUsers = users
		})
	}
	openModal() {
		this.modalService.open(this.addGroupRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}

	getNameByValue(value: any): string {
		const item = this.placedfrom.find(p => p.value === parseInt(value));
		return item ? item.name : 'Not Found';
	}

	removeGroup(group: any) {

		this.userService.removeGroup(group).subscribe((result: any) => {
			this.allUsergroups = result
			this.setTableData(result)
		});

	}
	addGroup() {
		if (this.addGroupForm.valid) {
			this.userService.addGroup(this.addGroupForm.value).subscribe((result: any) => {
				this.allUsergroups = result
				this.setTableData(result)
				this.modalService.dismissAll()
			});
		}
	}
	back(): void {
		this.location.back()
	}

	confirmDeletion(usergroup: any) {
		if (confirm('Would you like to delete this User Group?')) {
			this.removeGroup(usergroup)
		}
	}

	setTableData(usergroups: any[]) {

		this.usergroups = new MatTableDataSource(usergroups)
		this.usergroups.sort = this.sort
		this.usergroups.paginator = this.paginator

		//Set sorting to work with lower or upper case
		this.usergroups.sortingDataAccessor = this.sortingDataAccessor
	}

	sortingDataAccessor(data: any, sortHeaderID: string): string {
		return typeof data[sortHeaderID] === 'string' ?
			data[sortHeaderID].toLowerCase() :
			data[sortHeaderID]
	}

	announceSortChange(event) {

	}

	searchUserGroups() {
		this.onInput()
	}

	onInput() {
		const search = this.usergroupSearch.value
		this.isSearching = true
		this.setTableData(this.globalSearchService.filterItem(this.allUsergroups, search, 'user_group_id,name'))
		this.isSearching = false
	}

	exportPdf() {
		this.exporting = true;
		this.generateHtml().then((html) => {
			const encoded: string = this.globalSearchService.base64encode(html);
			const today = new Date();
			const data = {
				content: encoded,
				filename: this.filename,
				title: 'User Groups',
				subtitle: 'Created ' + today.toLocaleString(),
				landscape: true
			};

			this.printService.pdf(data).subscribe((result: any) => {
				this.exporting = false;
				this.globalSearchService.downloadPdf(result.content, data.filename);
			});
		}).catch(() => {
			this.exporting = false;
		});
	}

	exportXls() {
		this.exporting = true;
		this.generateHtml().then((html) => {
			const encoded: string = this.globalSearchService.base64encode(html);
			const today = new Date();
			const data = {
				content: encoded,
				filename: this.filename,
				title: 'User Groups',
				subtitle: 'Created ' + today.toLocaleString()
			};

			this.printService.xls(data).subscribe((result: any) => {
				this.exporting = false;
				this.globalSearchService.downloadXls(result.content, data.filename);
			});
		}).catch(() => {
			this.exporting = false;
		});
	}

	generateHtml(): Promise < string > {
		return new Promise((resolve) => {
			const rows = this.allUsergroups || [];
			let htmlParts: string[] = [];
			htmlParts.push('<div class="table">');
			htmlParts.push('<div class="bg-white mt-2 rounded">');
			htmlParts.push('<table class="table table-sm table-fixed collapsed">');
			htmlParts.push('<thead><tr>');
			htmlParts.push('<th>Group ID</th>');
			htmlParts.push('<th>Name</th>');
			htmlParts.push('<th>Sales Channel</th>');
			htmlParts.push('<th>#Users</th>');
			htmlParts.push('</tr></thead><tbody>');

			rows.forEach((g: any) => {
				htmlParts.push('<tr>');
				htmlParts.push(`<td>${g.user_group_id || ''}</td>`);
				htmlParts.push(`<td>${g.name || ''}</td>`);
				htmlParts.push(`<td>${this.getNameByValue(g.sales_channel) || ''}</td>`);
				htmlParts.push(`<td>${g.user_count || ''}</td>`);
				htmlParts.push('</tr>');
			});

			htmlParts.push('</tbody></table></div></div>');
			resolve(htmlParts.join(''));
			htmlParts = null;
		});
	}

}